import {} from "src/_common/interfaces/ApiReqRes";
import { SAGA_ACTIONS } from "src/_config";
import { useApiCall } from "../common/appApiCallHook";

export function useCommonApi() {
  const callApi = useApiCall();

  const getGenderList = (onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.COMMON.GENDER_LIST, null, onSuccess, onError);
  };
  // const getCountryList = (onSuccess: Function, onError: Function) => {
  //   callApi(SAGA_ACTIONS.COMMON.COUNTRY_LIST, null, onSuccess, onError);
  // };
  const getSecretQuestion = (onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.COMMON.SECRET_QUESTION_LIST, null, onSuccess, onError);
  };

  const getCountries = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.COMMON.COUNTRIES, data, onSuccess, onError);
  };
  const getStates = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.COMMON.STATES, data, onSuccess, onError);
  };
  const getCities = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.COMMON.CITIES, data, onSuccess, onError);
  };
  const newsletterSignup = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.COMMON.NEWSLETTER_SIGNUP, data, onSuccess, onError);
  };

  return {
    callGetGenderList: getGenderList,
    // callGetCountryList: getCountryList,
    callGetSecretQuestion: getSecretQuestion,
    callGetCountries: getCountries,
    callGetStates: getStates,
    callGetCities: getCities,
    callNewsletterSignup: newsletterSignup,
  };
}
